import React from "react"
import { generatePath, Link, useNavigate } from "react-router-dom"
import { Button, Flex, Space, Typography } from "antd"

import { paths } from "@src/app/paths"

export const SubMerchForm = () => {
  const navigate = useNavigate()

  return (
    <Space direction="vertical" size={0}>
      <Flex
        align="end"
        gap={24}
        justify="space-between"
        style={{ width: "100%" }}
        vertical
      >
        <Flex align="start" style={{ width: "100%" }} vertical>
          <Typography.Title style={{ fontSize: 20 }}>
            Team Members
          </Typography.Title>
          <Typography.Text
            style={{ fontSize: 16, fontWeight: 400, opacity: 0.65 }}
          >
            Add additional members to your company and set their permissions.
            All connected to the dashboard members will be shown here and
            available for anytime changes.
          </Typography.Text>
        </Flex>
        <Button
          htmlType="button"
          id="GENERATED_ID_SUBMERCH_BUTTON_ADD_BANK_DETAILS_1"
          onClick={() =>
            navigate(generatePath(paths.subMerchDetail, { id: "new" }))
          }
          size="large"
          type="primary"
        >
          Add a member
        </Button>
      </Flex>
    </Space>
  )
}
